import React, { useRef } from 'react';
import { FaPrint } from 'react-icons/fa';
import { Delete, DisplayNoneImprimir } from './styles';
import { fetchDataToPrint } from '~/services/printer/dataToPrint';
import { printHtmlInIframe } from '~/services/printer/printerUtils';
import toast from 'react-hot-toast';
import { useAuth } from '~/context/AuthContext';
import ReactToPrint from 'react-to-print';
import PrintBillsIndividual from '~/components/Prints/PrintBillsIndividual';

function OrdersBillOperation({ bill, userName, session }) {
  const componentRef = useRef(null);
  const { user } = useAuth();
  const iframeRef = useRef(null);

  const handleFetchDataToPrint = async (payload) => {
    try {
      const htmlResponse = await fetchDataToPrint(payload);
      printHtmlInIframe(iframeRef, htmlResponse);
    } catch (error) {
      toast.error('Erro ao buscar dados para impressão');
    }
  };
  return (
    <tr key={bill?.id}>
      <iframe ref={iframeRef} style={{ display: 'none' }} />
      <td>{userName}</td>
      <td>R${bill?.total_service_price}</td>

      <Delete>
        <FaPrint
          onClick={() => {
            handleFetchDataToPrint({
              print_type: 'individual_bill',
              individual_bill_id: bill.id,
            });
          }}
          size={21}
        />
      </Delete>
    </tr>
  );
}

export default OrdersBillOperation;
